import { isValidEmail } from '@acceligentllc/shared/utils/email';

import type { SpecialEmailsForm } from '../formModel';

const validateDomain = (email: string, acceptableDomains: string[]) => {
	const match = email.match(/^[A-Za-z0-9\-._%-+]+@(\w+[.-]?\w+).com/);
	return match !== null && acceptableDomains.includes(match[1]);
};

export function validate(values: SpecialEmailsForm, props) {
	const errors: ValidationErrors = {};

	if (values.enableScheduleBoardEmail && !values.scheduleBoardEmailUserGroup?.id) {
		errors.scheduleBoardEmailUserGroup = 'User group is required';
	}

	if (values.enablePastWorkOrdersNotification && !values.pastWorkOrdersNotificationUserGroup?.id) {
		errors.pastWorkOrdersNotificationUserGroup = 'User group is required';
	}

	if (values.enableNotifyYesterdaysBoard && !values.notifyYesterdaysBoardUserGroup?.id) {
		errors.notifyYesterdaysBoardUserGroup = 'User group is required';
	}

	if (values.enableNotifyFailed && !values.notifyFailedUserGroup?.id) {
		errors.notifyFailedUserGroup = 'User group is required';
	}

	if (values.enableInvoiceRemindersNotification && !values.notifyInvoiceRemindersFrom) {
		errors.notifyInvoiceRemindersFrom = 'Email is required';
	} else if (values.enableInvoiceRemindersNotification && !!values.notifyInvoiceRemindersFrom) {
		if (!isValidEmail(values.notifyInvoiceRemindersFrom)) {
			errors.notifyInvoiceRemindersFrom = 'This is not valid email format.';
			return errors;
		}
		const acceptableEmailDomains = ['acceligent'];
		if (props?.emailDomain) {
			acceptableEmailDomains.push(props.emailDomain.split('.')[0]);
		}
		if (!validateDomain(values.notifyInvoiceRemindersFrom, acceptableEmailDomains)) {
			errors.notifyInvoiceRemindersFrom = 'This email domain is not whitelisted. Please contact Acceligent support team for assistance.';
		}
	}

	return errors;
}
